var base = window.base;
var base;
(base = window.Aedu).Auth || (base.Auth = {});
window.base = base;